const React = require('react');
const Ripple = require('../../../../Ripple/');

module.exports = ({emitter, onChange, links = []}) => {
  const currentTab = emitter.getValue() || links[0].id;

  return (
    <div className="h45 layoutRow rlt9 rrt9 bxsh4c0.25 ovH (hA|dB)@m2">
      {links.map(({title, id}) => (
        <Ripple
          key={id}
          className={
            `fx1 layoutRow jcC aiC f16 fw3 tc ttU c3E4044 bgFAFAFA b0 br1 bs bcDCDCDC dn
           (fw7|cF|bg3E4044).active
           (bgA3A7AC4F):h:not[.active]
           (br0):last-child
           (pv15|br0|bt1)@m2
           (bt0):first-child@m2`
            + (id === currentTab ? ' active' : '')
          }
          onClick={() => {
            if (onChange) onChange();
            emitter.emit(id);
          }}
        >
          {title}
        </Ripple>
      ))}
    </div>
  )
}
